import { createLogger } from "@/lib/observability/logger";

export default async function loadPlacesLibrary() {
  const logger = createLogger("loadPlacesLibrary");
  if (
    !window.google ||
    !window.google.maps ||
    !window.google.maps.importLibrary
  ) {
    logger.logError(
      "loadPlacesLibrary",
      new Error("Google Maps API not loaded"),
    );
    throw new Error("Unable to load maps library. Please try again later.");
  }
  // Using the new dynamic library import for Places
  return (await google.maps.importLibrary(
    "places",
  )) as google.maps.PlacesLibrary;
}
